/**
 * Created by Carsten Bühler
 * User: c.buehler on 18.07.2016
 * Copyright: xdot GmbH 2015
 */

'use strict';

import PropTypes from 'external/prop-types';
import { AppContext, ConfigActions, getLocalConfigStore } from 'plugin/liferay-widgets-react-web';
import L from 'external/leaflet';

const LocalConfigStore = getLocalConfigStore(AppContext);

export default class RememberMapStatePlugin {

    constructor(props) {
        this.boundRequestHandled = false;
        this.boundRequestCb = this.boundRequestCb.bind(this);
    }


    initOptions(o) {

        const lastBounds = LocalConfigStore.getLocalConfig(this.getLastBoundKey());
        if (lastBounds && lastBounds.properties) {
            o.boundRequest = {
                bounds: L.latLngBounds(lastBounds.properties._southWest, lastBounds.properties._northEast),
                options: { animate: false },
                cb: this.boundRequestCb
            };
        }
        return o;
    }

    /*
     * Use this to mutate options pre update/map init
     * @param {object} o - options
     * @return {object} o - options
     */
    options(o) {
        return o;
    }

    init(map, o) {
        this.update(map, o);
    }

    update(map, o) {
        if (this.dragendListener) {
            map.off('moveend', this.dragendListener);
        }
        this.dragendListener = (e) => {
            let bounds = map.getBounds();
            ConfigActions.updateLocalConfig(this.getLastBoundKey(), {
                ...bounds
            });
        };

        map.on('moveend', this.dragendListener);

    }

    getLastBoundKey() {
        let key = 'Map_LastBounds';
        key = this.context && this.context.contextId ? key + '_' + this.context.contextId : key;
        return key;
    }

    boundRequestCb() {
        this.boundRequestHandled = true;
    }

}

RememberMapStatePlugin.contextTypes = {
    contextId: PropTypes.string
};



// WEBPACK FOOTER //
// ./js/plugins/RememberMapStatePlugin.js